import { render, staticRenderFns } from "./stu.vue?vue&type=template&id=6b1cc47e&scoped=true"
import script from "./stu.vue?vue&type=script&lang=js"
export * from "./stu.vue?vue&type=script&lang=js"
import style0 from "./stu.vue?vue&type=style&index=0&id=6b1cc47e&prod&scoped=scoped&lang=css"
import style1 from "./stu.vue?vue&type=style&index=1&id=6b1cc47e&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1cc47e",
  null
  
)

export default component.exports